import { IntervalType } from '@dokucoach/common-types';
import * as yup from 'yup';
import { object, ref, string } from 'yup';
import { ICheckboxValue, IUser } from '../../common';
import { IResident } from '../resident-creation';

export interface IEvents {
  id: string;
  text: string;
  displayFrom: Date;
  displayTo: Date | null;
  interval: IntervalType;
  intervalNumber: number;
  weekdays: ICheckboxValue;
  createdBy?: IUser;
  createdById: string;
  createdAt: Date;
  resident: IResident | null;
  houseDivisionId?: string | null;
}

export interface IEventsCreate {
  text: string;
  displayFrom: Date;
  displayTo?: Date | null;
  interval: IntervalType;
  intervalNumber: number | undefined;
  weekdays: ICheckboxValue | undefined;
  residentId: string | undefined;
  houseDivisionId?: string | null;
}

export interface IEventsUpdate {
  id: string;
  text: string;
  displayFrom: Date;
  displayTo?: Date | null;
  interval: IntervalType;
  intervalNumber: number | undefined;
  weekdays: ICheckboxValue | undefined;
  residentId: string | null;
  houseDivisionId?: string | null;
}

export const EventsCreateSchema = object({
  text: yup.string().required(),
  displayFrom: yup.date().required(),
  displayTo: yup.date().optional().nullable().min(ref('displayFrom')).default(null),
  intervalNumber: yup.mixed().when('interval', {
    is: (v: string) => v === IntervalType.INTERVAL,
    then: yup.number().required('Angabe erforderlich'),
  }),
  weekdays: yup.mixed().when('interval', {
    is: (v: string) => v === IntervalType.WEEKDAYS,
    then: yup.object().shape({
      value: yup.array().min(1).of(yup.string()).required('Angabe erforderlich'),
    }),
  }),
  interval: yup.string().required(),
  residentId: string().notRequired().nullable(),
  houseDivisionId: string().notRequired().nullable(),
});

export const EventsUpdateSchema = object({
  id: yup.string().required(),
  text: yup.string().required(),
  displayFrom: yup.date().required(),
  displayTo: yup.date().optional().nullable().min(ref('displayFrom')).default(null),
  intervalNumber: yup.mixed().when('interval', {
    is: (v: string) => v === IntervalType.INTERVAL,
    then: yup.number().required('Angabe erforderlich'),
  }),
  weekdays: yup.mixed().when('interval', {
    is: (v: string) => v === IntervalType.WEEKDAYS,
    then: yup.object().shape({
      value: yup.array().min(1).of(yup.string()).required('Angabe erforderlich'),
    }),
  }),
  interval: yup.string().required(),
  residentId: string().notRequired().nullable(),
  houseDivisionId: string().notRequired().nullable(),
});
